import { IShipper } from '@/_types';
import { useQueryState } from 'nuqs';
import { RefObject } from 'react';
import { Section } from '../../utils';
import WithCategories from './with-categories';
import WithoutCategories from './without-categories';

type Props = {
  brand: IShipper;
  sections: Section[];
  sectionRefs: RefObject<Record<string, HTMLDivElement | null>>;
};

const MainContent: React.FC<Props> = ({
  brand,
  sections,
  sectionRefs,
}) => {
  const [search] = useQueryState('search');
  return (
    <>
      {search ? (
        <WithoutCategories query={search} />
      ) : (
        <WithCategories
          brand={brand}
          sections={sections}
          sectionRefs={sectionRefs}
        />
      )}
    </>
  );
};

export default MainContent;
